import { ReplacePropertiesReturnType } from '@interfaces/common';
import IState from '@interfaces/redux/i-state';
import { clearCardsList, getCardsList, updateCard } from '@store/cards/action-creators';

export const mapStateToProps = (state: IState) =>
	({
		isShowInactive: state.cards.isShowInactive,
		cards: state.cards.list.result,
		isListFetching: state.cards.list.isFetching,
		updateFetchingRowId: state.cards.update.result,
		deleteFetchingRowId: state.cards.delete.result,
		listenTransactions: state.payments.listen.transactions,
		isFetchingAccountUpdate: state.accounts.update.isFetching,
		isAccountActive: state.accounts.item.result?.active,
	}) as const;

export const mapDispatchToProps = {
	clearCardsList,
	getCardsList,
	updateCard,
};

export type ICardsTableStateToProps = ReturnType<typeof mapStateToProps>;

export type ICardsTableDispatchToProps = ReplacePropertiesReturnType<typeof mapDispatchToProps, void>;
